<template>
  <transition name="expand">
    <div class="form" id="flow" data-aos="fade-up" data-aos-duration="400">
      <component
        :is="type"
        v-bind="{ steps, text_top, text_bottom, type, terms }"
      ></component>
    </div>
  </transition>
</template>

<script>
import ompolstring from "./ompolstring.vue";
import sell from "./sell.vue";

export default {
  components: { sell, ompolstring },
  props: {
    steps: { required: true, type: String },
    text_top: { required: true, type: String },
    text_bottom: { required: true, type: String },
    type: { required: true, type: String },
    terms: { required: true, type: String }
  }
};
</script>

<style lang="scss" scoped>
.expand-enter-active,
.expand-leave-active {
  transition: all 2s ease;
  max-height: 1200px;
  overflow: hidden;
}
.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
